<template>
    <v-dialog
        :value="isOpen"
        max-width="550px"
        transition="slide-y-transition"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    Zmiana hasła
                </h1>
            </v-card-title>

            <v-card-text class="text-center">
                <v-container fluid>
                    <v-row>
                        <v-col cols="12">
                            <v-text-field
                                v-model="currentPassword"
                                label="Aktualne hasło"
                                type="password"
                                autocomplete="new-password"
                                outlined
                                dense
                                :error-messages="currentPasswordErrors"
                            />
                            <v-text-field
                                v-model="newPassword"
                                label="Nowe hasło"
                                :type="showPassword ? 'text' : 'password'"
                                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                counter
                                hint="Ilość znaków 8-20, duża litera, cyfra oraz znak specjalny."
                                outlined
                                dense
                                :error-messages="newPasswordErrors"
                                @input="$v.newPassword.$touch()"
                                @click:append="showPassword = !showPassword"
                            />
                            <v-text-field
                                v-model="confirmedNewPassword"
                                label="Powtórz hasło"
                                :type="showPasswordRepeat ? 'text' : 'password'"
                                :append-icon="showPasswordRepeat ? 'mdi-eye' : 'mdi-eye-off'"
                                counter
                                persistent-hint
                                outlined
                                dense
                                :error-messages="confirmedNewPasswordError"
                                @input="$v.confirmedNewPassword.$touch()"
                                @click:append="showPasswordRepeat = !showPasswordRepeat"
                            />
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>

            <v-divider />

            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    data-sentry-label="Zamknij"
                    :disabled="actionLoading"
                    @click="onClose()"
                >
                    Anuluj
                </v-btn>
                <v-spacer />
                <v-btn
                    color="success"
                    text
                    :loading="actionLoading"
                    data-sentry-label="Zapisz"
                    @click="saveNewPassword()"
                >
                    Zapisz
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { errorHandler } from '@/utils/errorHandler'
import { required, sameAs } from 'vuelidate/lib/validators'
import { passwordRequirements } from '@/utils/customValidators'

export default {
    name: 'ChangePasswordDialog',
    props: {
        isOpen: {
            type: Boolean
        },
    },
    data() {
        return {
            currentPassword: null,
            newPassword: null,
            confirmedNewPassword: null,
            actionLoading: false,
            showPassword: false,
            showPasswordRepeat: false
        }
    },
    validations: {
        currentPassword: {
            required
        },
        newPassword: {
            required,
            passwordRequirements,
        },
        confirmedNewPassword: {
            required,
            sameAsNewPassword: sameAs('newPassword')
        }
    },
    computed: {
        currentPasswordErrors() {
            const errors = []

            if (!this.$v.currentPassword.$dirty) return errors
            !this.$v.currentPassword.required && errors.push('Proszę podać aktualne hasło.')

            return errors
        },
        newPasswordErrors() {
            const errors = []

            if (!this.$v.newPassword.$dirty) return errors
            !this.$v.newPassword.required && errors.push('Proszę podać nowe hasło.')
            !this.$v.newPassword.passwordRequirements && errors.push('Hasło musi zawierać od 8 do 20 znaków, wielką literę, cyfrę oraz znak specjalny.')

            return errors
        },
        confirmedNewPasswordError() {
            const errors = []

            if (!this.$v.confirmedNewPassword.$dirty) return errors
            !this.$v.confirmedNewPassword.required && errors.push('Proszę podać nowe hasło.')
            !this.$v.confirmedNewPassword.sameAsNewPassword && errors.push('Hasła nie są identyczne.')

            return errors
        },
    },
    methods: {
        saveNewPassword() {
            this.$v.$touch()

            if (this.$v.$invalid) {
                this.$store.dispatch('showNotification', {
                    type: 'error',
                    message: this.$i18n.t('validations.invalidMessage')
                })

                return
            }

            this.actionLoading = true

            this.$store.dispatch('changePassword', {
                userId: this.$store.state.user.userId,
                passwords: {
                    oldPassword: this.currentPassword,
                    password: this.newPassword
                }
            })
                .then(() => {
                    this.onClose()
                })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.actionLoading = false
                })
        },
        onClose() {
            setTimeout(() => {
                this.currentPassword = null
                this.newPassword = null
                this.confirmedNewPassword = null
            }, 500)
            this.$emit('on-close')
            this.$v.$reset()
        },
    }
}
</script>

